import { ICellRendererParams } from '@ag-grid-community/core'
import { Button } from 'components/common'
import Modal from 'components/modal'
import toast from 'react-hot-toast'
import { deleteChain } from 'utils/api/chainApi'

type Props = {
  isOpen: boolean
  closeModal: () => void
  params?: ICellRendererParams
}

const ConfirmDeleteChainModal = ({ params, closeModal, isOpen }: Props) => {
  const cancelDelete = () => {
    if (params?.data?._id) {
      const rowNode = params.api.getRowNode(params.data._id)
      rowNode?.setSelected(false)
    }
    closeModal()
  }

  const handleDeleteChain = async () => {
    if (!params?.data?._id) return

    const deleteToast = toast.loading('Deleting Chain...', {
      duration: Infinity,
    })
    try {
      await deleteChain(params.data._id)
      const rowNode = params.api.getRowNode(params.data._id)
      params.api.applyTransaction({ remove: [rowNode?.data] })
      toast.success(
        `Chain "${params?.data?.chainName}" deleted successfully!`,
        {
          duration: 3000,
          id: deleteToast,
        },
      )
      closeModal()
    } catch {
      toast.error('Failed to delete chain.', {
        duration: 3000,
        id: deleteToast,
      })
    }
  }

  return (
    <Modal
      width={550}
      title={`Confirm delete "${params?.data?.chainName}" ?`}
      titleClassname="text-xl font-semibold max-w-xl"
      isOpen={isOpen}
      closeModal={cancelDelete}
      customStyle={{ padding: '25px 40px' }}
    >
      <>
        <div>
          Are you sure you want to delete{' '}
          <strong>{params?.data?.chainName}</strong>? This action cannot be
          undone.
        </div>
        <div className="mt-6 flex w-full items-center gap-5">
          <Button
            onClick={handleDeleteChain}
            className="w-full"
            buttonText="Confirm"
            type="button"
          />
          <Button
            className="w-full"
            buttonText="Cancel"
            variant="outline"
            type="button"
            onClick={cancelDelete}
          />
        </div>
      </>
    </Modal>
  )
}

export default ConfirmDeleteChainModal
